module.exports = __webpack_public_path__ + "static/media/1.0f9b3337.svg";